module.exports = __webpack_public_path__ + "static/media/boleto.53d88a6b.jpg";